export default __webpack_public_path__ + "static/media/coffee-beans.64a4ed51.png";